/**
 * Official NYC DECE logo, hosted on the shared solved-forms S3 bucket so
 * the same asset is used by the FCCERS Tool, Snapshot Tool, and any other
 * DECE-branded property.
 */
const LOGO_URL =
  'https://solved-forms.s3.us-east-2.amazonaws.com/nyc_dece_logo.png';

export function DeceLogo({ className }: { className?: string }) {
  return (
    <img
      src={LOGO_URL}
      alt="NYC DECE"
      className={className ?? 'h-10 w-auto'}
    />
  );
}
